<template>
  <span
    v-if="hotelClassification.classificationVisible"
    class="classification"
    :class="{
      inline,
      'official-classification': !hotelClassification.estimatedClassification,
    }"
  >
    <IconSvg
      v-for="(star, index) in hotelClassification.classificationValue"
      filepath="star.svg"
      class="star-svg"
      :key="'star' + index"
    />

    <span
      v-if="hotelClassification.classificationSuperior"
      class="superior"
      v-tooltip="superiorTooltip"
    >
      {{ superiorText }}
    </span>

    <span
      v-if="hotelClassification.estimatedClassification"
      class="animod-stars"
      :class="{ below: estimateBelowStars }"
      v-tooltip="estimatedTooltip"
    >
      {{ animodStarsText }}
    </span>
    <span
      v-else
      class="official-stars"
      :class="{ below: estimateBelowStars }"
      v-tooltip="officialTooltip"
    >
      {{ officialStarsText }}
    </span>
  </span>
</template>

<script>
export default {
  name: "Classification",
  data() {
    return {
      estimatedTooltip: this.$t("HotelDetails.classification.estimatedText"),
      officialTooltip: this.$t("HotelDetails.classification.officialText"),
    };
  },
  props: {
    hotelClassification: {
      type: Object,
      required: true,
    },
    estimateBelowStars: Boolean,
    inline: Boolean,
  },
  computed: {
    animodStarsText() {
      return this.inline
        ? this.$t("HotelDetails.classification.animodStars").replace("-", "\n")
        : this.$t("HotelDetails.classification.animodStars");
    },
    officialStarsText() {
      return this.inline
        ? this.$t("HotelDetails.classification.officialStars").replace(
            "-",
            "\n"
          )
        : this.$t("HotelDetails.classification.officialStars");
    },
    superiorText() {
      if (this.hotelClassification.estimatedClassification) {
        return this.inline ? "+" : this.$t("HotelDetails.classification.plus");
      } else {
        return this.inline
          ? "S"
          : this.$t("HotelDetails.classification.superior");
      }
    },
    superiorTooltip() {
      if (this.hotelClassification.estimatedClassification) {
        return this.inline ? "Plus" : "";
      } else {
        return this.inline ? "Superior" : "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.classification {
  font-size: inherit;
  display: flex;
  align-items: center;
  position: relative;
  margin-right: 0.5em;
  margin-top: 2px;

  .star-svg {
    width: 1em;
    height: 1em;
    fill: currentColor;

    &:not(:last-of-type) {
      margin-right: 0.15em;
    }
  }

  &.official-classification {
    .star-svg {
      fill: #d2a106;
    }
  }

  .superior {
    margin-left: 5px;
    font-size: .8em;
    line-height: normal;
    text-decoration: none;
  }

  .animod-stars,
  .official-stars {
    position: relative;
    top: 0;
    white-space: nowrap;
    margin-left: 5px;

    &.below {
      position: absolute;
      top: 1.75em;
      line-height: 1.5em;
      font-size: 0.6em;
      margin-left: 0;
    }
  }

  &.inline {
    .animod-stars,
    .official-stars {
      white-space: normal;
      max-width: 4em;
      display: block;
      line-height: 1;
      font-size: 12px;
      text-align: center;
      margin-left: 3px;
    }

    .superior {
      font-size: 1em;
      line-height: normal;
    }
  }
}
</style>
